module.exports = __webpack_public_path__ + "media/images/icons/flist_short_s-cef0cdc81d1a0dab15b3d411ed7c6240.svg";